import { MouseEvent, useEffect } from "react";
import "./landingComponent.scss";
import logo from "../../assets/images/mim-logo.png";
import { RedirectLoginOptions, useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router";
import { Button } from "react-bootstrap";

const LandingComponent = () => {
  const navigate = useNavigate();

  const { isAuthenticated, loginWithRedirect } = useAuth0();

  const btnLoginUserHandler = async (event: MouseEvent) => {
    const opts: RedirectLoginOptions = {
      redirectUri: `${window.location.origin}`,
    };

    loginWithRedirect(opts);
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/organisations");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  return (
    <>
      {!isAuthenticated && (
        <main>
          <div className="main-content-container w-100">
            <div className="grid-container">
              <div className="row w-100 h-100 align-items-center">
                <div className="col-lg-5 d-none d-md-block">{/* empty */}</div>
                <div className="col-lg-7">
                  <div className="login-container">
                    <div className="logoContainer">
                      <img
                        src={logo}
                        className="logo-login mt-60"
                        alt="MiM logo"
                      />{" "}
                      {/* <span className="mx-3">Internal CMS</span> */}
                    </div>
                    <div className="loginButtonContainer">
                      <Button
                        variant="primary-3"
                        onClick={btnLoginUserHandler}
                        className="btn-login"
                      >
                        Login
                      </Button>
                    </div>
                    <p className="text-center text-light">
                      Don't have an account? Contact System Admin
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      )}
    </>
  );
};

export default LandingComponent;
